<template>
  <AccordionV2 :title="`${t('label_chatroom_settings')}`" v-model:is-open="isOpen">
    <div class="room">
      <div class="item">
        <p>{{ t('label_interpretation_chatroom_name') }}</p>
        <input
          class="app-t-input"
          type="text"
          :placeholder="`${t('enter_chat_room_name')}`"
          v-model="form.title"
          v-cursor-end
        />
      </div>
      <div class="item">
        <p>{{ t('label_chatroom_description') }}</p>
        <textarea
          class="app-textarea"
          v-model="form.description"
          :placeholder="`${t('alert_enter_chatroom_description')}`"
        ></textarea>
      </div>
    </div>
  </AccordionV2>
</template>

<script setup lang="ts">
import AccordionV2 from '@/components/domains/mobile/common/AccordionV2.vue';
import { ChatItem } from '@/types/components';
import { DEFAULT_CHAT_CREATE_FORM } from '@/utils/constants/chat';

const form = defineModel<ChatItem>('form', { default: DEFAULT_CHAT_CREATE_FORM });

const { t } = useI18n();

const isOpen = ref<boolean>(true);
</script>

<style lang="scss" scoped>
.room {
  p {
    font-size: $font-size-psmall;
    padding-right: $size-s;
  }
  .item {
    &:not(:first-child) {
      margin-top: $size-xl;
    }
    p {
      margin-bottom: $size-s;
    }
  }
}
</style>
